import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Button, Small } from '@bigcommerce/big-design';

import { updateShipments } from '../../redux/actions/purchaseOrders';
import { assignmentUpdate } from '../../redux/actions/assignments';

const UpdateSupplierAssignmentModal = ({ payload, 
  supplier, 
  modalProductId,
  modalVariantId,
  modalOptions,
  modalProductName,
  modalType,
  modalAssignment,
  showUpdateSupplierAssignmentModal, 
  setShowUpdateSupplierAssignmentModal,
  updateAssignment,
  settings
}) => {

  const [supplierSku, setSupplierSku] = useState(null);
  const [supplierPrice, setSupplierPrice] = useState(null);
  const [minimumQuantity, setMinimumQuantity] = useState(null);
  const [orderMultiple, setOrderMultiple] = useState(null);
  const [packQuantity, setPackQuantity] = useState(null);

  const changeSku = (event) => {
    let value = event.target.value;
    setSupplierSku(value);
  }

  const changePrice = (event) => {
    let value = event.target.value.replace(/[^\d.-]+/g, '');;
    setSupplierPrice(value);
  }

  const changeOrderMultiple = (event) => {
    let value = parseInt(event.target.value).toString();
    setOrderMultiple(value);
  }

  const changePackQuantity = (event) => {
    let value = parseInt(event.target.value).toString();
    setPackQuantity(value);
  }

  const changeMinimum = (event) => {
    let value = parseInt(event.target.value);
    setMinimumQuantity(value);
  }

  const update = () => {
    let assignment = {
      product_id: modalProductId,
      variant_id: modalVariantId
    }

    // let min = minimumQuantity.toString()

    let min = modalAssignment.minimum_order;

    if(minimumQuantity) {
      min = minimumQuantity.toString();
    }

    let packQuant = modalAssignment.pack_quantity;

    if(settings?.settings?.pack_quantities && packQuantity) {
      packQuant = packQuantity.toString();
    }

    let assignmentValues = {
      supplierSku: (supplierSku || modalAssignment.supplier_sku),
      supplierPrice: (supplierPrice || modalAssignment.supplier_price),
      minOrder: min,
      packQuantity: packQuant,
      orderMultiple: (orderMultiple || modalAssignment.order_multiple)
    }

    updateAssignment(payload, supplier.id, assignment, assignmentValues);
    setShowUpdateSupplierAssignmentModal(false);
  }

  return (
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowUpdateSupplierAssignmentModal(false),
          },
          { text: 'Update Assignment', onClick: () => update() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="Update Assignment"
        isOpen={showUpdateSupplierAssignmentModal}
        onClose={() => setShowUpdateSupplierAssignmentModal(false)}
      >
        <H3><strong>Supplier</strong>: { supplier.supplier_name }</H3>
        <H3><strong>Product</strong>: {modalProductName}</H3>

        { modalOptions && modalOptions.map(option =>
            <li>
              <strong>{ option.option_display_name || option.display_name }</strong>: { option.label || option.display_value }
            </li>
          )
        }

        <Small>
          Current Supplier SKU: {modalAssignment.supplier_sku}<br/>
          Current Supplier Price: {modalAssignment.supplier_price}<br/>
          Current MOQ: {modalAssignment.minimum_order}
          { settings?.settings?.order_multiples &&
            <><br/>Current Order Multiple: {modalAssignment.order_multiple}</>
          }
          { settings?.settings?.pack_quantities &&
            <><br/>Current Pack Quantity: {modalAssignment.pack_quantity}</>
          } 
        </Small>

        <Input
          label="Supplier SKU"
          onChange={changeSku}
          placeholder={modalAssignment.supplier_sku}
          type="text"
          value={supplierSku}
          required
        />
        
        <Input
          label="Supplier Price"
          onChange={changePrice}
          placeholder={modalAssignment.supplier_price}
          type="number"
          value={supplierPrice}
          required
        />

        <Input
          label="Minimum Quantity"
          onChange={changeMinimum}
          placeholder={modalAssignment.minimum_order}
          type="number"
          value={minimumQuantity}
          required
        />

        { settings?.settings?.order_multiples &&
          <Input
            label="Order Multiple"
            onChange={changeOrderMultiple}
            placeholder={modalAssignment.order_multiple}
            type="number"
            value={orderMultiple}
            required
          />
        }

        { settings?.settings?.pack_quantities &&
          <Input
            label="Pack Quantity"
            onChange={changePackQuantity}
            placeholder={modalAssignment.pack_quantity}
            type="number"
            value={packQuantity}
            required
          />
        }

      </Modal>
    </>
  )

}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  updateAssignment: (payload, supplierId, assignment, assignmentValues) => dispatch(assignmentUpdate(payload, supplierId, assignment, assignmentValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSupplierAssignmentModal);
